(function () {
  function trackCta(link) {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: "listicle_cta_click",
      destination: link.getAttribute("href"),
      label: link.textContent.trim().replace(/\s+/g, " "),
    });
  }

  document.querySelectorAll("[data-wbl-page]").forEach(function (page) {
    var heroCta = page.querySelector("[data-wbl-hero-cta]");
    var sticky = page.querySelector("[data-wbl-sticky]");

    page.querySelectorAll("[data-wbl-cta]").forEach(function (link) {
      link.addEventListener("click", function () {
        trackCta(link);
      });
    });

    if (!heroCta || !sticky) return;

    function setStickyVisible(visible) {
      sticky.classList.toggle("is-visible", visible);
      sticky.setAttribute("aria-hidden", visible ? "false" : "true");
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setStickyVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      observer.observe(heroCta);
    } else {
      window.addEventListener(
        "scroll",
        function () {
          setStickyVisible(heroCta.getBoundingClientRect().bottom < 0);
        },
        { passive: true }
      );
    }
  });
})();
